import { useTranslation } from "react-i18next"
import PageLayout from "components/layout/PageLayout"
import { useGetBusinessUnitDetailQuery, useGetBusinessUnitsQuery } from "./api/businessUnitApiSlice"
import { NavLink, useLocation } from "react-router-dom"
import { useState } from "react"
import { MapContainer, Marker, TileLayer, Tooltip } from "react-leaflet"
import * as L from "leaflet"
import BusinessUnitNav from "./views/BusinessUnitNav"
import EmploymentsSimpleTable from "../employment/components/EmployeeSimpleTable"
import EntityFingerprint from "components/commons/EntityFingerprint"


function BusinessUnit() {

    const [t] = useTranslation("global")
    let location = useLocation()
    let businessUnit = location.state

    const [map, setMap] = useState(null)

    const [buGuid, setBuGuid] = useState(businessUnit.guid)

    // API
    const {
        data: response,
        isFetching,
        isLoading,
        isSuccess: detailIsSuccess,
        isError,
        error,
        refetch,
    } = useGetBusinessUnitDetailQuery(buGuid)

    const {
        data: businessUnits,
        isSuccess: businessUnitsIsSuccess,
    } = useGetBusinessUnitsQuery()

    let content


    function handleBusinessUnitChange(businessUnit) {
        setBuGuid(businessUnit.guid)
        map.setView([businessUnit.gps.latitude, businessUnit.gps.longitude])
    }

    let mapBounds
    if (businessUnitsIsSuccess) {
        mapBounds = [
            [Math.max(...businessUnits.filter(bu => (bu.businessUnit.gps != null)).map(bu => bu.businessUnit.gps.latitude)), Math.min(...businessUnits.filter(bu => (bu.businessUnit.gps != null)).map(bu => bu.businessUnit.gps.longitude))],
            [Math.min(...businessUnits.filter(bu => (bu.businessUnit.gps != null)).map(bu => bu.businessUnit.gps.latitude)), Math.max(...businessUnits.filter(bu => (bu.businessUnit.gps != null)).map(bu => bu.businessUnit.gps.longitude))]
        ]
    }

    var markerSize = { 'sm': [28, 35], 'md': [35, 44], 'lg': [42, 53] };
    var markerAnchor = { 'sm': [14, 35], 'md': [17, 44], 'lg': [21, 53] };
    var markerPopupAnchor = { 'sm': [1, -35], 'md': [1, -44], 'lg': [2, -53] };

    function getMarkerIcon(location) {
        return new L.Icon({
            iconUrl: `https://assets.mapquestapi.com/icon/v2/marker-lg-2c363c-2bb673-${location.name}.png`,
            iconSize: markerSize.lg,
            iconAnchor: markerAnchor.lg,
            popupAnchor: markerPopupAnchor.lg
        })
    }


    content =
        <>
            {detailIsSuccess && <BusinessUnitNav businessUnit={response.businessUnit} />}

            <div className="row">


                <div className="col-sm-6">
                    {
                        detailIsSuccess &&
                        <div className="card bg-dark text-white mb-4">
                            <div className="card-header">
                                <i className="fa-solid fa-circle-info"></i> {t("property.infos")}
                            </div>
                            <div className="card-body">

                                <div className="row">
                                    <div className="col">
                                        <span className="text-muted">{response.businessUnit.code}</span>
                                        <h2>{response.businessUnit.name}</h2><br />
                                        <h5><i className="fas fa-users"></i> {response.employees.length}</h5>
                                    </div>

                                    <div className="col">

                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <EntityFingerprint guid={response.businessUnit.guid}/>
                            </div>
                        </div>
                    }

                    {
                        detailIsSuccess && response.businessUnit.gps != null &&
                        <div className="card bg-dark text-white mb-4 col-6">
                            <div className="card-header">
                                <i className="fa-solid fa-location-dot"></i>  {t("property.location")}
                            </div>
                            <div className="card-body">
                                <h5> GPS</h5>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td><b className="text-eh">Lat</b></td>
                                            <td>{response.businessUnit.gps.latitude}</td>
                                        </tr>
                                        <tr>
                                            <td><b className="text-eh">Long</b></td>
                                            <td>{response.businessUnit.gps.longitude}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    }

                </div>

                <div className="col-sm-6">
                    {businessUnitsIsSuccess && detailIsSuccess && response.businessUnit.gps != null &&

                        <MapContainer
                            ref={setMap}
                            bounds={mapBounds}
                            boundsOptions={{ padding: [100, 100] }}
                            scrollWheelZoom={true}>
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            {businessUnits.filter(businessUnitInfo => (businessUnitInfo.businessUnit.gps != null)).map(bu => (
                                <Marker
                                    key={bu.businessUnit.guid}
                                    icon={getMarkerIcon(bu.businessUnit)}
                                    opacity={bu.businessUnit.guid == buGuid ? "1" : "0.5"}
                                    position={[bu.businessUnit.gps.latitude, bu.businessUnit.gps.longitude]}
                                    eventHandlers={{
                                        click: () => {
                                            handleBusinessUnitChange(bu.businessUnit)
                                        },
                                    }}
                                >
                                    <Tooltip><b>{bu.businessUnit.name}</b></Tooltip>
                                </Marker>
                            ))}
                        </MapContainer>
                    }
                </div>
            </div>
            {
                detailIsSuccess && <EmploymentsSimpleTable employmentsData={response.employees} />

            }
        </>



    return <PageLayout
        pageTitle={t("entity.businessUnit")}
        bodyContent={content}
        onPageRefresh={refetch}
        isError={isError}
        errorMsg={error}
        isLoadingPage={isLoading}
        isLoadingContent={isFetching}
    />


}

export default BusinessUnit